import { connect } from 'react-redux';
import BulkUpdateMenu from '../../../components/bulk-update-menu';
import { BulkActionDataTypes } from '../../../services/bulk-update-type-data';
import get from 'lodash.get';
import Global from '../../../store/global-selectors';

// TODO: instead of passing the idSelector we can pass just a straight collection of Id's, perhaps the same thing for getAdditionalDisabledCriteria
const mapStateToProps = (state, props) => {
  const { idsSelector, actionSections, dataTypeKey } = props;
  const bulkUpdateTypeData = BulkActionDataTypes.getBulkUpdateTypeData(dataTypeKey);
  const ids = idsSelector(state);
  const allSelected = Global.selectSelectedOrdersAreAllOrdersSelected(state);
  const getAdditionalDisabledCriteria = get(props, 'getAdditionalDisabledCriteria') || (() => false);

  const optionsShouldBeDisabled = (!allSelected && ids.length === 0) || getAdditionalDisabledCriteria(state);
  return {
    optionsShouldBeDisabled,
    ids,
    actionSections,
    dataTypeKey,
    bulkUpdateTypeData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { optionsShouldBeDisabled, ids, bulkUpdateTypeData, actionSections } = stateProps;
  const { dispatch } = dispatchProps;

  const fullActionSections = actionSections.map((section) => {
    return {
      ...section,
      ...ownProps,
      ids,
      actions: section.actions.map((action) => ({
        ...action,
        disabled: ownProps.actionsDisabled || optionsShouldBeDisabled,
        actionHandler: action.makeHandler(dispatch, bulkUpdateTypeData),
      })),
    };
  });

  return {
    ...ownProps,
    ids,
    optionsShouldBeDisabled,
    actionSections: fullActionSections,
  };
};

export const BaseBulkUpdateMenuContainer = connect(mapStateToProps, mapDispatchToProps, mergeProps)(BulkUpdateMenu);
